<p-dialog [(visible)]="visible" [header]="editingVehicle ? 'Editar Veículo' : 'Adicionar ' + categoryLabel"
  [modal]="true" [style]="{width: '90vw', maxWidth: '700px'}" [draggable]="false" [resizable]="false"
  (onHide)="closeDialog()" styleClass="vehicle-dialog">

  <div class="dialog-content">
    <div class="form-field" *ngIf="!editingVehicle && showTypeSelect">
      <label class="field-label">Tipo de Veículo <span class="required">*</span></label>
      <p-dropdown [options]="vehicleTypes" [(ngModel)]="form.tipo" optionLabel="label" optionValue="id"
        placeholder="Selecione o tipo" (onChange)="onTypeChange()" styleClass="w-full">
        <ng-template let-item pTemplate="item">
          <div class="dropdown-item">
            <i [class]="item.icon"></i>
            <span>{{ item.label }}</span>
          </div>
        </ng-template>
      </p-dropdown>
    </div>

    <div class="form-field">
      <label class="field-label">Marca <span class="required">*</span></label>
      <p-dropdown [options]="marcas" [(ngModel)]="form.marca" optionLabel="nome" [filter]="true"
        placeholder="Selecione a marca" (onChange)="emitBrandChange()" [showClear]="true" styleClass="w-full">
      </p-dropdown>
    </div>

    <div class="form-field">
      <label class="field-label">Modelo <span class="required">*</span></label>
      <p-dropdown [options]="modelos" [(ngModel)]="form.modelo" optionLabel="nome" [filter]="true"
        placeholder="Selecione o modelo" [disabled]="!form.marca" (onChange)="emitModelChange()"
        emptyMessage="Primeiro selecione a marca" styleClass="w-full">
      </p-dropdown>
    </div>

    <div class="form-row">
      <div class="form-field">
        <label class="field-label">Ano <span class="required">*</span></label>
        <p-dropdown [options]="anos" [(ngModel)]="form.ano" optionLabel="ano" [filter]="true" placeholder="Ano"
          [disabled]="!form.modelo" (onChange)="emitYearChange()" styleClass="w-full">
        </p-dropdown>
      </div>
      <div class="form-field">
        <label class="field-label">
          Cor <span class="optional">(opcional)</span>
        </label>
        <input type="text" pInputText [(ngModel)]="form.cor" placeholder="Ex: Preto" class="w-full input-styling">
      </div>
    </div>

    <div class="form-field">
      <label class="field-label">Versão <span class="required">*</span></label>
      <p-dropdown [options]="versoes" [(ngModel)]="form.versao" optionLabel="nome" [filter]="true"
        placeholder="Selecione a versão" [disabled]="!form.ano" (onChange)="emitVersionChange()"
        emptyMessage="Primeiro selecione o ano" styleClass="w-full" appendTo="body"
        [panelStyle]="{'width': '100%', 'max-width': '90vw', 'min-width': '200px'}">
        <ng-template pTemplate="selectedItem" let-item>
          <div class="text-truncate">
            {{ item.nome }}
          </div>
        </ng-template>

        <!-- <ng-template let-item pTemplate="item">
          <div class="item-wrap">
            {{ item.nome }}
          </div>
        </ng-template> -->
        <ng-template let-item pTemplate="item">
          <div style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; width: 100%;"
          [pTooltip]="item.nome" tooltipPosition="left"
          >
            {{ item.nome}}
          </div>
        </ng-template>
      </p-dropdown>
    </div>

    <div class="form-row">
      <div class="form-field">
        <label class="field-label">Placa <span class="optional">(opcional)</span></label>
        <input type="text" pInputText [(ngModel)]="form.placa" placeholder="ABC-1234" class="w-full input-styling"
          maxlength="8" (input)="formatPlaca($event)">
      </div>
      <div class="form-field">
        <label class="field-label">Quilometragem <span class="optional">(opcional)</span></label>
        <p-inputNumber [(ngModel)]="form.quilometragem" placeholder="0" [min]="0" [useGrouping]="true"
          styleClass="w-full">
        </p-inputNumber>
      </div>
    </div>

    <div class="form-field">
      <label class="field-label">Observações <span class="optional">(opcional)</span></label>
      <textarea pInputTextarea [(ngModel)]="form.observacoes" placeholder="Informações adicionais..." rows="3"
        class="w-full input-styling"></textarea>
    </div>

    <div class="form-field checkbox-field">
      <p-checkbox [(ngModel)]="form.isPrimary" [binary]="true" inputId="isPrimary"></p-checkbox>
      <label for="isPrimary" class="checkbox-label">Definir como veículo principal desta categoria</label>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="dialog-footer">
      <button class="dialog-btn btn-cancel" (click)="closeDialog()">Cancelar</button>
      <button class="dialog-btn btn-save" (click)="save()" [disabled]="!isFormValid()">
        <i class="pi pi-check"></i> {{ editingVehicle ? 'Salvar' : 'Adicionar' }}
      </button>
    </div>
  </ng-template>
</p-dialog>
